<div class="widget-title">NPS</div>
<div class="chartContainer">
    <div *ngIf="!noData" class="row">
        <div class="col-12">
            <div [innerHTML]="score" class="title-score"></div>
            <span class="footer">Score</span>
        </div>
    </div>
    <div *ngIf="!noData" class="row">
        <div class="col-6">
            <div [innerHTML]="responses" class="response-title"></div>
            <span class="footer">Response</span>
        </div>
        <div class="col-6">
            <div [innerHTML]="totalResponses" class="response-title"></div>
            <span class="footer">Total Responses</span>
        </div>
    </div>
    <div *ngIf="noData" class="noData pad">No Data Available</div>
</div>